<div class="form-group">
    <label class="input-label">Later than:</label>
    <input class="form-control"
           name="minRows"
           type="date"
           value="{{fieldOptions.validate.laterThan}}"
           [(ngModel)]="fieldOptions.validate.laterThan">
</div>